import React from 'react';
import styled from 'styled-components';

import Zoom from 'react-reveal/Zoom';
import CPButton from './CPButton';

const CPItemStyle = styled.div`
  text-align: center;
  .cp_icon {
    width: 100%;
    height: 300px;
    object-fit: contain;
  }

  .icon__title {
    font-size: 10rem;
    font-family: 'Montserrat SemiBold';
  }

  /* .para {
    margin-top: 2rem;
  } */
  @media only screen and (max-width: 768px) {
    .cp_icon {
      width: 50%;
      height: 150px;
    }
  }
`;

export default function CPItem({ icon, text, link }) {
  return (
    <CPItemStyle>
      <Zoom>
        <img className="cp_icon" src={icon} alt="this is icon" />
      </Zoom>
      <h1 className="icon__title ">{text}</h1>
      <CPButton btnText="Profile" btnLink={link} outline="true" />
    </CPItemStyle>
  );
}
